import React from "react";
import { Sparkles, Mail, Truck, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="bg-slate-900 text-slate-200 mt-20">
    <div className="max-w-7xl mx-auto px-6 py-14">
      <div className="grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-9 h-9 rounded-xl bg-indigo-600 flex items-center justify-center">
              <Sparkles className="w-5 h-5 text-white" />
            </div>
            <div className="font-display font-extrabold text-xl">SupplySprout</div>
          </div>
          <p className="text-sm text-slate-400 max-w-xs">The stationery store built for parents & teachers — notebooks, pens, art, backpacks, classroom essentials & tech.</p>
        </div>

        <div>
          <div className="font-bold mb-3 text-sm uppercase tracking-wider">Shop</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop" className="hover:text-white">All supplies</Link></li>
            <li><Link to="/shop?category=notebooks" className="hover:text-white">Notebooks</Link></li>
            <li><Link to="/shop?category=writing" className="hover:text-white">Writing</Link></li>
            <li><Link to="/wholesale" className="hover:text-white">For schools (bulk)</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-bold mb-3 text-sm uppercase tracking-wider">Account</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/orders" className="hover:text-white">My orders</Link></li>
            <li><Link to="/lists" className="hover:text-white">My class lists</Link></li>
            <li><Link to="/teacher-verification" className="hover:text-white">Verified teacher 15% off</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-bold mb-3 text-sm uppercase tracking-wider">Help & legal</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/contact" className="hover:text-white">Contact us</Link></li>
            <li><Link to="/refund" className="hover:text-white">Returns & refunds</Link></li>
            <li><Link to="/terms" className="hover:text-white">Terms of service</Link></li>
            <li><Link to="/privacy" className="hover:text-white">Privacy policy</Link></li>
          </ul>
        </div>
      </div>

      <div className="mt-10 pt-6 border-t border-slate-800 grid sm:grid-cols-3 gap-4 text-xs text-slate-400">
        <div className="flex items-center gap-2"><Truck className="w-4 h-4" />UK delivery 7-12 days</div>
        <div className="flex items-center gap-2"><ShieldCheck className="w-4 h-4" />Secure Stripe checkout</div>
        <div className="flex items-center gap-2"><Mail className="w-4 h-4" />support@supplysprout.co.uk</div>
      </div>
    </div>
    <div className="border-t border-slate-800 py-6 text-center text-xs text-slate-500">© 2026 SupplySprout — Built for parents & teachers.</div>
  </footer>
);
